module.exports = __webpack_public_path__ + "static/2front-graphic-design-1-9c64c78e8eab9571323aae7f183a8eb2.png";